// extracted by mini-css-extract-plugin
module.exports = {"burgerIngredient":"burger-constructor-item_burgerIngredient__G0IIR","dragIcon":"burger-constructor-item_dragIcon__Oyde4","dragPreview":"burger-constructor-item_dragPreview__1Evvb"};